const mark = {
  u: {
    parseDOM: [{ tag: 'u' }],
    toDOM: () => ['u', 0]
  }
};

export default mark;
